export default [
  {
    path: '',
    name: 'geo-main',
    redirect: 'home',
    component: () => import('./MainPage.vue'),
    children: [
      {
        path: 'form',
        name: 'geo-form',
        component: () => import('./pages/FormPage.vue'),
      },
      {
        path: 'conversation',
        name: 'geo-conversation',
        component: () => import('./pages/ConversationPage.vue'),
      },
    ],
  },
  {
    path: 'rights',
    name: 'geo-rights',
    component: () => import('./pages/rights-page/RightsPage.vue'),
  },
  {
    path: 'view-effect',
    name: 'geo-view-effect',
    meta: { skipAuth: true },
    component: () => import('./pages/view-effect/ViewEffect.vue'),
  },
]
